import styled from "@emotion/styled";
import {  Form, Input, Select } from "antd";
import React, { FC } from "react";
import { GetLogoBankResponse, MasterProcessResponse } from "services/interface";
import { Image } from 'antd';
import noImage from "assets/images/no-image.png";
const { Option } = Select;

interface BankDescriptionFormProps {
  is_active: boolean;
  dataLogo: GetLogoBankResponse[] | undefined;
  dataBankType: MasterProcessResponse | undefined;
}

const BankDescriptionForm: FC<BankDescriptionFormProps> = (
    {
        is_active, 
        dataLogo,
        dataBankType
    }) => {

    const childrenBank: React.ReactNode[] = [];
    childrenBank.push(<Option key='' value=''>เลือกธนาคาร</Option>)

    dataLogo?.map((item) => {
      return childrenBank.push(
        <Option key={item.bank_key} value={item.bank_key}>
            <OptionContent>
              <ImageWrapper>
                <Image src={item.image ?? noImage}  alt={item.name} preview={false} />
              </ImageWrapper>
              <span>{item.name}</span>
            </OptionContent>
        </Option>
      );
    });

    const childrenBankType: React.ReactNode[] = [];
    childrenBankType.push(<Option key='' value=''>เลือกประเภทธนาคาร</Option>)

    dataBankType?.data?.map((item) => {
      return childrenBankType.push(
        <Option key={item.id} value={item.id}>
          {item.description}
        </Option>
      );
    });
  return (
 
    <FormWrapper>
      <Form.Item
        label="ธนาคาร"
        name="bank_key"
        rules={[{ required: is_active, message: "กรุณาเลือกธนาคาร" }]}
        labelAlign="left"
      >
          <Select
            placeholder="ธนาคาร"
            optionFilterProp="children"
          >
            {childrenBank}
          </Select>  
      </Form.Item>
      <Form.Item
        label="ชื่อบัญชี"
        name="account_name"
        rules={[{ required: is_active, message: "กรุณากรอกชื่อบัญชี" }]}
          labelAlign="left"
              >
        <Input
          placeholder="กรุณากรอกชื่อบัญชี"
          maxLength={120}
          size="small"
          autoComplete="off"
        />      
      </Form.Item>
      <Form.Item
        label="หมายเลขบัญชี"
        name="account_no"
        rules={[{ required: is_active, message: "กรุณากรอกเลขบัญชี" }]}
          labelAlign="left"
      >
        <Input
          placeholder="กรุณากรอกหมายเลขบัญชี"
          maxLength={120}
          size="small"
          autoComplete="off"
          type="text"
        />      
      </Form.Item>
      <Form.Item
        label="ประเภทบัญชี"
        name="bank_type_id"
        rules={[{ required: is_active, message: "กรุณาเลือกประเภทธนาคาร" }]}
          labelAlign="left"
      >
          <Select
            placeholder="ประเภทธนาคาร"
            optionFilterProp="children"
          >
            {childrenBankType}
          </Select>  
      </Form.Item>
    </FormWrapper>

  );
};

export default BankDescriptionForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  border-radius: 8px;
`;

const OptionContent = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  margin-right: 8px;
  width: 20px;  
  height: 20px; 
  img {
    margin-top: -10px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;